import type { FoldingCardProp } from "@components/FoldingCardProp.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getReasonsAbout(tenant: Tenant): FoldingCardProp[] {
	return [
		{
			title: "Férovost na prvním místě",
			desc: "Nafouknuté fakturace? To ve Fastest nevedeme. Hrajeme fér a odvedenou práci podrobně vykazujeme.",
		},
		{
			title: "Razíme kvalitu, ne kvantitu",
			desc: "Nesekáme projekty jako Baťa cvičky. Raději jich tvoříme méně a pořádně, protože nám záleží na kvalitě.",
		},
		{
			title: "Neděláme krabicová řešení",
			desc: "Ke každému klientovi přistupujeme individuálně a připravujeme mu IT řešení na míru.",
		},
		{
			title: "Důkladná analýza na úvod",
			desc: "Nejsme agentura, která vás hodí do zajetých škatulek. Na základě úvodní analýzy důkladně zjistíme, co potřebujete. Děláme ji ale, jen když je opravdu potřeba.",
		},
		{
			title: "Preferujeme agilní vývoj",
			desc: "Máme rádi agilní metodu vývoje. Díky němu IT projekt vzniká průběžně a klient zároveň vidí, za co v jednotlivých fázích platí.",
		},
		{
			title: "Dodržujeme termíny",
			desc: "Vždy děláme maximum, abychom dodrželi smluvené termíny. Protože ale netvoříme krabicová řešení, nemíváme hotovo do dvou dnů.",
		},
	];
}
